<div class="container mt-5">
  <div class="card auth-card mx-auto">
    <div class="card-header"><i class="fa fa-key mr-2"></i>Forgot Password</div>
    <div class="card-body">
      <p>Enter your email address and we will send you a link to reset your password.</p>

      <form [formGroup]="forgotPasswordForm" autocomplete="off" novalidate (ngSubmit)="forgotPassword(forgotPasswordForm.value)">
        <div class="form-group">
          <label for="email">Email address</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fa fa-envelope"></i></span>
            </div>
            <input type="text" id="email" formControlName="email" class="form-control" placeholder="Email address" />
          </div>
          @if (validateControl('email') && hasError('email', 'required')) {
            <small class="text-danger">Email is required</small>
          }
        </div>

        @if (showError) {
          <div class="alert alert-danger py-2" role="alert">
            {{errorMessage}}
          </div>
        }
        @if (showSuccess) {
          <div class="alert alert-success py-2" role="alert">
            {{successMessage}}
          </div>
        }

        <button type="submit" class="btn btn-primary btn-block mt-4" [disabled]="!forgotPasswordForm.valid">Submit</button>
        <div class="text-center mt-3">
          <a routerLink="/"><i class="fa fa-arrow-left mr-1"></i>Back to login</a>
        </div>
      </form>
    </div>
  </div>
</div>
